import reportApi from "../api/reportApi";
import { beginAjaxCall, ajaxCallError } from "./ajaxStatusActions";
import * as actionTypes from "../constants/actionTypes";
import * as config from "../constants/config";
import {refreshLogin} from "./authenticationActions";

export function loadDivisionDataSuccess(data){
    return { type: actionTypes.LOAD_DIVISION_DATA_AJAX_SUCCESS, data };
}

export function loadDivisionData(filterCriteria){
    return dispatch => {
        dispatch(beginAjaxCall());
        return reportApi.getDivisionData(filterCriteria)
            .then(data =>
            {
                dispatch(loadDivisionDataSuccess(data));
            })
            .catch(error =>
                {
                    if(config.useRefreshToken === error) {
                        dispatch(refreshLogin())
                            .then(() => {
                                dispatch(loadDivisionData(filterCriteria));
                            });
                    }
                    else {
                        dispatch(ajaxCallError(error));
                        throw (error);
                    }
                }
            );
    };
}

export function saveDivisionReportSearchCriteria(criteria) {
    return { type: actionTypes.SAVE_DIVISION_REPORT_SEARCH_CRITERIA, criteria};
}


export function exportDivisionData(filterCriteria) {
    return () => {
        reportApi.exportDivisionData(filterCriteria);
    };
}

export function loadSummaryDataSuccess(data){
    return { type: actionTypes.LOAD_SUMMARY_REPORT_DATA_AJAX_SUCCESS, data };
}

export function loadSummaryData(filterCriteria){
    return dispatch => {
        dispatch(beginAjaxCall());

        return reportApi.getSummaryReportData(filterCriteria)
            .then(data =>
            {
                dispatch(loadSummaryDataSuccess(data));
            })
            .catch(error =>
                {
                    if(config.useRefreshToken === error) {
                        dispatch(refreshLogin())
                            .then(() => {
                                dispatch(loadSummaryData(filterCriteria));
                            });
                    }
                    else {
                        dispatch(ajaxCallError(error));
                        throw (error);
                    }
                }
            );
    };
}

export function saveSummaryReportSearchCriteria(criteria) {
    return { type: actionTypes.SAVE_SUMMARY_REPORT_SEARCH_CRITERIA, criteria};
}
